import React, { useState, ReactNode } from 'react';
import { MenuItem, MenuList, Paper, Popover } from '@material-ui/core';

interface DropdownActionsProps {
  actions: {
    title: string;
    disabled: boolean;
    onClick?(): void;
  }[];
  children: ReactNode;
}

const DropdownActions: React.FC<DropdownActionsProps> = ({ actions, children }: DropdownActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLSpanElement | null>(null);

  const handleClose = (event: { target: Node | null }) => {
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }

    setAnchorEl(null);
  };

  const handleActionsClick = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent> | React.KeyboardEvent<HTMLSpanElement>
  ) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const onActionClick = (action: DropdownActionsProps['actions'][0]) => {
    setAnchorEl(null);
    if (typeof action.onClick !== 'undefined') {
      action.onClick();
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      {/* The <span> element has a child element that allows keyboard interaction */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <span aria-describedby={id} onClick={handleActionsClick} onKeyDown={handleActionsClick}>
        {children}
      </span>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Paper>
          <MenuList id="split-button-menu">
            {actions.map((action) => (
              <MenuItem
                key={action.title}
                dense
                disabled={typeof action.disabled !== 'undefined' && action.disabled}
                onClick={() => onActionClick(action)}
              >
                {action.title}
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      </Popover>
    </div>
  );
};

export default DropdownActions;
